import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { PPA_SOURCE_API } from '@/api';
import config from './ppaMeterConfigs';

const state = {
  tableData: [],
  tableConfig: config.fields,
  tableConfigMv90: config.fieldsMv90,
};

const actions = {
  async fetchPPAMeterData({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      ppas: parameters.ppasSelected,
      mv90: parameters.hasMv90,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await PPA_SOURCE_API.post('/meter/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Meter Data', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};